__turbopack_context__.v({
  "absorptionBar": "style-module-scss-module__rfsMBq__absorptionBar",
  "absorptionFill": "style-module-scss-module__rfsMBq__absorptionFill",
  "absorptionHint": "style-module-scss-module__rfsMBq__absorptionHint",
  "absorptionLabel": "style-module-scss-module__rfsMBq__absorptionLabel",
  "absorptionTrack": "style-module-scss-module__rfsMBq__absorptionTrack",
  "absorptionValue": "style-module-scss-module__rfsMBq__absorptionValue",
  "breakdownCard": "style-module-scss-module__rfsMBq__breakdownCard",
  "breakdownCount": "style-module-scss-module__rfsMBq__breakdownCount",
  "breakdownGrid": "style-module-scss-module__rfsMBq__breakdownGrid",
  "breakdownLabel": "style-module-scss-module__rfsMBq__breakdownLabel",
  "breakdownSection": "style-module-scss-module__rfsMBq__breakdownSection",
  "breakdownValue": "style-module-scss-module__rfsMBq__breakdownValue",
  "component": "style-module-scss-module__rfsMBq__component",
  "description": "style-module-scss-module__rfsMBq__description",
  "heading": "style-module-scss-module__rfsMBq__heading",
  "inventoryCount": "style-module-scss-module__rfsMBq__inventoryCount",
  "inventoryItem": "style-module-scss-module__rfsMBq__inventoryItem",
  "inventoryRow": "style-module-scss-module__rfsMBq__inventoryRow",
  "inventoryType": "style-module-scss-module__rfsMBq__inventoryType",
  "negative": "style-module-scss-module__rfsMBq__negative",
  "neutral": "style-module-scss-module__rfsMBq__neutral",
  "positive": "style-module-scss-module__rfsMBq__positive",
  "roiCard": "style-module-scss-module__rfsMBq__roiCard",
  "roiGrid": "style-module-scss-module__rfsMBq__roiGrid",
  "roiHint": "style-module-scss-module__rfsMBq__roiHint",
  "roiLabel": "style-module-scss-module__rfsMBq__roiLabel",
  "roiValue": "style-module-scss-module__rfsMBq__roiValue",
  "sectionHeading": "style-module-scss-module__rfsMBq__sectionHeading",
  "smallSample": "style-module-scss-module__rfsMBq__smallSample",
  "statCard": "style-module-scss-module__rfsMBq__statCard",
  "statHint": "style-module-scss-module__rfsMBq__statHint",
  "statIcon": "style-module-scss-module__rfsMBq__statIcon",
  "statLabel": "style-module-scss-module__rfsMBq__statLabel",
  "statValue": "style-module-scss-module__rfsMBq__statValue",
  "statsGrid": "style-module-scss-module__rfsMBq__statsGrid",
  "trendLabel": "style-module-scss-module__rfsMBq__trendLabel",
  "trendRow": "style-module-scss-module__rfsMBq__trendRow",
  "trendValue": "style-module-scss-module__rfsMBq__trendValue",
  "trendsHeading": "style-module-scss-module__rfsMBq__trendsHeading",
  "trendsSection": "style-module-scss-module__rfsMBq__trendsSection",
  "volatilityHint": "style-module-scss-module__rfsMBq__volatilityHint",
});
